// src/store/productSlice.js

import { createSlice } from '@reduxjs/toolkit';
import { fetchProductById } from '../../api/productApi';

const productSlice = createSlice({
  name: 'product',
  initialState: {
    products: {},         // { [productId]: productInfo }
    loading: false,
    error: null,
  },
  reducers: {
    clearProductState: (state) => {
      state.products = {};
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProductById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        const { productId, product } = action.payload;
        state.products[productId] = product;
        state.loading = false;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to fetch product';
      });
  },
});

export const { clearProductState } = productSlice.actions;
export default productSlice.reducer;
